var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9222",
    "data-name": "Group 9222",
    transform: "translate(-10 -297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_13-car",
    "data-name": "13-car",
    transform: "translate(19 314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M70.889,236a2.889,2.889,0,1,0,2.889,2.889A2.889,2.889,0,0,0,70.889,236Zm0,4.222a1.333,1.333,0,1,1,1.333-1.333A1.333,1.333,0,0,1,70.889,240.222Z",
    transform: "translate(-64.444 -228.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M358.889,236a2.889,2.889,0,1,0,2.889,2.889A2.889,2.889,0,0,0,358.889,236Zm0,4.222a1.333,1.333,0,1,1,1.333-1.333A1.333,1.333,0,0,1,358.889,240.222Z",
    transform: "translate(-336.445 -228.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M30.3,105.169l-5.189-.947-4.417-3.665A2.45,2.45,0,0,0,19.14,100H12.632a2.432,2.432,0,0,0-1.909.917l-2.822,3.3H6a2,2,0,0,0-2,2v2.444a2.447,2.447,0,0,0,2.444,2.444h.508a3.556,3.556,0,1,1,6.984,0h9.016a3.556,3.556,0,1,1,6.984,0H30a2,2,0,0,0,2-2v-1.965A1.988,1.988,0,0,0,30.3,105.169Zm-16.522-1.613a.667.667,0,0,1-.667.667H10.18a.333.333,0,0,1-.253-.55l1.94-2.272a.667.667,0,0,1,.507-.233h.738a.667.667,0,0,1,.667.667Zm3.333,3.111h-.889a.667.667,0,1,1,0-1.333h.889a.667.667,0,1,1,0,1.333Zm5.249-2.428L16,104.224a.667.667,0,0,1-.665-.667v-1.724a.667.667,0,0,1,.667-.667h3.2a.667.667,0,0,1,.413.143l2.957,2.333a.333.333,0,0,1-.207.6Z",
    transform: "translate(-4 -100)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    transform: "translate(10 297)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9222);
export default __webpack_public_path__ + "static/media/Group 9222.232913cf8ebd06235fadc011387fcc2b.svg";
export { ForwardRef as ReactComponent };